var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container pt-3 px-3",attrs:{"fluid":""}},[_vm._m(0),_c('AllUsers',{staticClass:"shadow"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-3 mb-5"},[_c('h3',[_vm._v("Manage Users")]),_c('p',[_vm._v("Manage your account users.")])])
}]

export { render, staticRenderFns }